/* IT HIPPIE — visionneuse photo « l'atelier » (nov. 2026).
   Ouverte depuis les photos du pop-up d'ajout rapide (snippets/ith-quick-add.liquid) :
   window.ithPhotoViewer.open(urls, index, title).
   Fond crème, glisser d'une photo à l'autre (scroll-snap natif), vignettes en bas,
   zoom : double-tap / double-clic, pincement à deux doigts, puis glisser pour se déplacer. */
(function () {
  if (window.ithPhotoViewer) return;

  var CSS = ''
    + '.ithpv{position:fixed;top:0;right:0;bottom:0;left:0;z-index:2147483647 !important;background:#fdfbf4;display:flex;flex-direction:column;color:#2c2c2a;font-family:inherit}'
    + '.ithpv[hidden]{display:none}'
    + '.ithpv__top{display:flex;align-items:center;justify-content:space-between;height:52px;padding:0 8px 0 18px;flex:none}'
    + '.ithpv__count{font-size:11px;letter-spacing:.16em;text-transform:uppercase}'
    + '.ithpv__close{width:44px;height:44px;border:0;background:none;font-size:26px;line-height:1;color:#2c2c2a;cursor:pointer}'
    + '.ithpv__track{flex:1 1 auto;min-height:0;display:flex;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;scrollbar-width:none;-webkit-overflow-scrolling:touch;overscroll-behavior:contain}'
    + '.ithpv__track::-webkit-scrollbar{display:none}'
    + '.ithpv.is-zoomed .ithpv__track{overflow:hidden;touch-action:none}'
    + '.ithpv__slide{flex:0 0 100%;height:100%;scroll-snap-align:center;display:flex;align-items:center;justify-content:center;overflow:hidden;touch-action:pan-x}'
    + '.ithpv__img{max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain;user-select:none;-webkit-user-drag:none;transition:transform .25s ease;transform-origin:50% 50%;cursor:zoom-in}'
    + '.ithpv.is-zoomed .ithpv__img.is-active{cursor:grab}'
    + '.ithpv__img.is-moving{transition:none}'
    + '.ithpv__thumbs{flex:none;display:flex;justify-content:center;gap:8px;padding:12px 12px calc(14px + env(safe-area-inset-bottom));overflow-x:auto;scrollbar-width:none}'
    + '.ithpv__thumbs::-webkit-scrollbar{display:none}'
    + '.ithpv__thumb{flex:none;width:44px;height:60px;padding:0;border:0;background:#f3efe6;cursor:pointer;opacity:.55;outline:1px solid transparent;outline-offset:2px;transition:opacity .2s}'
    + '.ithpv__thumb img{width:100%;height:100%;object-fit:cover;display:block}'
    + '.ithpv__thumb.is-active{opacity:1;outline-color:#6E1C24}'
    + '.ithpv__thumb:focus-visible,.ithpv__close:focus-visible,.ithpv__arrow:focus-visible{outline:2px solid #6E1C24;outline-offset:2px}'
    + '.ithpv__arrow{position:absolute;top:50%;transform:translateY(-50%);width:44px;height:44px;border-radius:50%;border:1px solid #e6e1d6;background:#fdfbf4;color:#2c2c2a;font-size:22px;line-height:1;cursor:pointer;display:none}'
    + '.ithpv__arrow--prev{left:18px}.ithpv__arrow--next{right:18px}'
    + '@media (hover:hover) and (min-width:750px){.ithpv__arrow{display:block}}'
    + '.ithpv__hint{position:absolute;left:50%;bottom:96px;transform:translateX(-50%);font-size:11px;letter-spacing:.12em;text-transform:uppercase;background:rgba(253,251,244,.9);padding:5px 10px;pointer-events:none;transition:opacity .4s;white-space:nowrap}'
    + '@media (prefers-reduced-motion:reduce){.ithpv__img{transition:none}}';

  var el, track, thumbs, count, urls = [], idx = 0, lastFocus = null;
  var zoom = { s: 1, x: 0, y: 0 };

  function sized(u, w) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function build() {
    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);
    el = document.createElement('div');
    el.className = 'ithpv';
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Photos du produit');
    el.innerHTML = '<div class="ithpv__top"><span class="ithpv__count" aria-live="polite"></span>'
      + '<button type="button" class="ithpv__close" aria-label="Fermer les photos">&times;</button></div>'
      + '<div class="ithpv__track"></div>'
      + '<button type="button" class="ithpv__arrow ithpv__arrow--prev" aria-label="Photo précédente">&#8249;</button>'
      + '<button type="button" class="ithpv__arrow ithpv__arrow--next" aria-label="Photo suivante">&#8250;</button>'
      + '<div class="ithpv__thumbs" role="tablist"></div>'
      + '<span class="ithpv__hint">Touchez deux fois pour zoomer</span>';
    document.body.appendChild(el);
    track = el.querySelector('.ithpv__track');
    thumbs = el.querySelector('.ithpv__thumbs');
    count = el.querySelector('.ithpv__count');

    /* Les clics dans la visionneuse ne doivent pas fermer le tiroir panier ni le pop-up dessous */
    el.addEventListener('click', function (e) { e.stopPropagation(); });

    el.querySelector('.ithpv__close').addEventListener('click', close);
    el.querySelector('.ithpv__arrow--prev').addEventListener('click', function () { go(idx - 1); });
    el.querySelector('.ithpv__arrow--next').addEventListener('click', function () { go(idx + 1); });
    thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('.ithpv__thumb');
      if (b) go(parseInt(b.getAttribute('data-i'), 10));
    });

    var t = null;
    track.addEventListener('scroll', function () {
      if (t) clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== idx) { idx = i; resetZoom(); mark(); }
      }, 60);
    }, { passive: true });

    bindZoom();

    document.addEventListener('keydown', function (e) {
      if (el.hidden) return;
      if (e.key === 'Escape') { e.stopImmediatePropagation(); e.preventDefault(); close(); }
      else if (e.key === 'ArrowRight') go(idx + 1);
      else if (e.key === 'ArrowLeft') go(idx - 1);
    }, true);
  }

  function mark() {
    count.textContent = (idx + 1) + ' / ' + urls.length;
    thumbs.querySelectorAll('.ithpv__thumb').forEach(function (b, i) {
      b.classList.toggle('is-active', i === idx);
      b.setAttribute('aria-selected', i === idx ? 'true' : 'false');
    });
  }

  function go(i, instant) {
    if (i < 0 || i >= urls.length) return;
    resetZoom();
    idx = i;
    track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
    mark();
  }

  function apply(img, moving) {
    if (!img) return;
    img.classList.toggle('is-moving', !!moving);
    img.style.transform = zoom.s > 1 ? 'translate(' + zoom.x + 'px,' + zoom.y + 'px) scale(' + zoom.s + ')' : '';
    el.classList.toggle('is-zoomed', zoom.s > 1);
    track.querySelectorAll('.ithpv__img').forEach(function (im) { im.classList.toggle('is-active', im === img); });
  }

  function resetZoom() {
    zoom = { s: 1, x: 0, y: 0 };
    if (track) track.querySelectorAll('.ithpv__img').forEach(function (im) { im.style.transform = ''; });
    if (el) el.classList.remove('is-zoomed');
  }

  /* Empêche de sortir l'image du cadre une fois zoomée */
  function clampPan(img) {
    var w = img.offsetWidth, h = img.offsetHeight;
    var mx = (w * zoom.s - w) / 2, my = (h * zoom.s - h) / 2;
    zoom.x = Math.max(-mx, Math.min(mx, zoom.x));
    zoom.y = Math.max(-my, Math.min(my, zoom.y));
  }

  /* Zoom centré sur le point touché (cx, cy) */
  function zoomAt(img, cx, cy, s) {
    var r = img.getBoundingClientRect();
    var k = r.width / img.offsetWidth;
    var ox = (cx - (r.left + r.width / 2)) / k, oy = (cy - (r.top + r.height / 2)) / k;
    zoom.s = s;
    zoom.x = s === 1 ? 0 : -ox * (s - 1);
    zoom.y = s === 1 ? 0 : -oy * (s - 1);
    clampPan(img);
    apply(img);
  }

  function bindZoom() {
    var pts = {}, start = null, lastTap = 0;
    function hideHint() { var h = el.querySelector('.ithpv__hint'); if (h) h.style.opacity = '0'; }

    track.addEventListener('dblclick', function (e) {
      var img = e.target.closest('.ithpv__img');
      if (!img) return;
      hideHint();
      zoomAt(img, e.clientX, e.clientY, zoom.s > 1 ? 1 : 2.5);
    });

    track.addEventListener('pointerdown', function (e) {
      var img = e.target.closest('.ithpv__img');
      if (!img) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pts);
      if (ids.length === 2) {
        var a = pts[ids[0]], b = pts[ids[1]];
        start = { d: Math.hypot(a.x - b.x, a.y - b.y), s: zoom.s, img: img, pinch: true };
        hideHint();
      } else if (ids.length === 1) {
        var now = Date.now();
        if (e.pointerType !== 'mouse' && now - lastTap < 300) {
          hideHint();
          zoomAt(img, e.clientX, e.clientY, zoom.s > 1 ? 1 : 2.5);
          lastTap = 0;
          start = null;
          return;
        }
        lastTap = now;
        start = zoom.s > 1 ? { x: e.clientX, y: e.clientY, ox: zoom.x, oy: zoom.y, img: img, pan: true } : null;
        if (start) { try { img.setPointerCapture(e.pointerId); } catch (er) {} }
      }
    });

    track.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId]) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (!start) return;
      if (start.pinch) {
        var ids = Object.keys(pts);
        if (ids.length < 2) return;
        var a = pts[ids[0]], b = pts[ids[1]];
        zoom.s = Math.max(1, Math.min(4, start.s * Math.hypot(a.x - b.x, a.y - b.y) / Math.max(1, start.d)));
        if (zoom.s === 1) { zoom.x = 0; zoom.y = 0; }
        clampPan(start.img);
        apply(start.img, true);
      } else if (start.pan) {
        zoom.x = start.ox + (e.clientX - start.x);
        zoom.y = start.oy + (e.clientY - start.y);
        clampPan(start.img);
        apply(start.img, true);
      }
    });

    function end(e) {
      delete pts[e.pointerId];
      if (start && start.img) apply(start.img, false);
      if (Object.keys(pts).length === 0) start = null;
    }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);

    track.addEventListener('touchmove', function (e) {
      if (zoom.s > 1 || e.touches.length > 1) e.preventDefault();
    }, { passive: false });
  }

  function open(list, i, title) {
    if (!list || !list.length) return;
    if (!el) build();
    document.body.appendChild(el); /* toujours en dernier : passe devant le pop-up (même z-index) */
    urls = list.slice();
    idx = Math.max(0, Math.min(urls.length - 1, i || 0));
    lastFocus = document.activeElement;
    track.innerHTML = '';
    thumbs.innerHTML = '';
    urls.forEach(function (u, n) {
      var s = document.createElement('div');
      s.className = 'ithpv__slide';
      var im = document.createElement('img');
      im.className = 'ithpv__img';
      im.src = sized(u, 1600);
      im.srcset = sized(u, 800) + ' 800w, ' + sized(u, 1200) + ' 1200w, ' + sized(u, 1600) + ' 1600w, ' + sized(u, 2048) + ' 2048w';
      im.sizes = '100vw';
      im.alt = (title || 'Photo') + ' — ' + (n + 1) + ' sur ' + urls.length;
      im.draggable = false;
      if (Math.abs(n - idx) > 1) im.loading = 'lazy';
      s.appendChild(im);
      track.appendChild(s);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ithpv__thumb';
      b.setAttribute('role', 'tab');
      b.setAttribute('data-i', n);
      b.setAttribute('aria-label', 'Photo ' + (n + 1));
      b.innerHTML = '<img alt="" loading="lazy" src="' + sized(u, 120) + '">';
      thumbs.appendChild(b);
    });
    thumbs.style.display = urls.length > 1 ? '' : 'none';
    el.querySelectorAll('.ithpv__arrow').forEach(function (a) { a.style.visibility = urls.length > 1 ? '' : 'hidden'; });
    var hint = el.querySelector('.ithpv__hint');
    if (hint) { hint.style.opacity = '1'; setTimeout(function () { hint.style.opacity = '0'; }, 2200); }
    resetZoom();
    el.hidden = false;
    requestAnimationFrame(function () { go(idx, true); });
    el.querySelector('.ithpv__close').focus({ preventScroll: true });
  }

  function close() {
    if (!el) return;
    el.hidden = true;
    resetZoom();
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  window.ithPhotoViewer = { open: open, close: close };
})();
